import LoginLayout from '../../layouts/LoginLayout'
import Login from './Login'

export default LoginLayout(Login)
